module.exports = __webpack_public_path__ + "assets/img/button-report.ade03f65.png";